import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionInfoStatus } from '@models/subscription.model';

@Component({
	selector: 'subscription-info-modal',
	template: require('./subscription-info-modal.html'),
	styles: [require('./subscription-info-modal.scss')]
})
export class SubscriptionInfoModal {
	@Input('subscriptionInfo') subscriptionInfo: SubscriptionInfoStatus;
	@Input('currentPlan') currentPlan: Array<string>;
	@Input('customerInfo') customerInfo: Array<string>;
	@Input('newPlan') newPlan: Array<string>;

	constructor(private activeModal: NgbActiveModal) {}

	closeModal(): void {
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/admin/subscription-info/subscription-info-modal/subscription-info-modal.ts